import React, { Fragment, PureComponent } from 'react';
import classNames from 'classnames';

import isFunction from 'lodash/isFunction';

import { Icon } from '@lumapps/lumx/react';
import { mdiChevronDown, mdiDragVertical } from '@lumapps/lumx/icons';

/**
 * Renders an accordion box, that is, a panel with a title whose content
 * expands when clicking on it.
 */
export class AccordionBox extends PureComponent {
    constructor(props) {
        super(props);
        this.state = { value: props.value || false };
        this.toggle = () => {
            const value = this.state.value;
            this.setState({ value: !this.state.value });

            if (isFunction(props.customToggleAction) && !value) {
                props.customToggleAction();
            }
        };
    }

    render() {
        const {
            border = true,
            children,
            color = 'primary',
            customHeader,
            dragHandleProps,
            label,
            variant = 'default',
        } = this.props;
        const { value } = this.state;

        return (
            <div
                className={classNames(
                    'custom-accordion-box',
                    variant === 'simple' && 'custom-accordion-box--simple',
                    `custom-accordion-box--${color}`,
                    `custom-accordion-box--is-${value ? 'open' : 'close'}`,
                    !border && 'custom-accordion-box--no-border',
                )}
            >
                <div className="custom-accordion-box__header" onClick={this.toggle}>
                    {customHeader ? (
                        customHeader
                    ) : (
                        <Fragment>
                            {dragHandleProps && (
                                <div className="custom-accordion-box__handle" {...dragHandleProps}>
                                    <Icon icon={mdiDragVertical} />
                                </div>
                            )}
                            <span className="custom-accordion-box__label">{label}</span>
                            <Icon className="custom-accordion-box__chevron" icon={mdiChevronDown} />
                        </Fragment>
                    )}
                </div>
                {value && (
                    <div className="custom-accordion-box__content">
                        <div className="ph+">{children}</div>
                    </div>
                )}
            </div>
        );
    }
}
